import { useMemo } from "react";
import { CodeMirrorEditor } from "./CodeMirrorEditor";
import { postgresSQL, catalogToSqlSchema } from "../editor/lang-sql";
import { sqlLinter } from "../editor/lang-sql/lint";
import { linter } from "@codemirror/lint";
import { useSchemaStore, useServersStore } from "../store";

interface SqlEditorProps {
  value: string;
  onChange: (value: string) => void;
  placeholder?: string;
  onExecute?: () => void;
  defaultSchema?: string;
}

export function SqlEditor({ value, onChange, placeholder, onExecute, defaultSchema }: SqlEditorProps) {
  const activeServerId = useServersStore((s) => s.activeServerId);
  const schemaCache = useSchemaStore((s) => s.schemaCache);

  const sqlSchemaConfig = useMemo(() => {
    if (!activeServerId) return null;
    const cached = schemaCache[activeServerId];
    if (!cached?.catalogJson || cached.catalogKind !== "postgres-catalog") return null;
    return catalogToSqlSchema(cached.catalogJson, defaultSchema);
  }, [activeServerId, schemaCache, defaultSchema]);

  const extensions = useMemo(() => {
    const tableNames = sqlSchemaConfig?.tables.map((t) => t.label) ?? [];

    return [
      postgresSQL(sqlSchemaConfig?.schema),
      linter(sqlLinter({ tableNames })),
    ];
  }, [sqlSchemaConfig]);

  return (
    <CodeMirrorEditor
      value={value}
      onChange={onChange}
      extensions={extensions}
      {...(placeholder ? { placeholder } : {})}
      {...(onExecute ? { onExecute } : {})}
    />
  );
}
